import PropTypes from 'prop-types';
import React from 'react';
import './CreditCardFormProfile.scss';
import Logger from 'services/logger';

const Condensed = ({
  cardsList,
  cardNumber,
  cardLegend,
  textChangeView,
  onPressChangeView,
}) => {
  if (!cardsList || !cardNumber || !textChangeView || !onPressChangeView) {
    Logger.error(
      'CondensedForm from CreditCardFormProfile required props are missing!',
    );
    return null;
  }
  return (
    <div className={'ccfp__content__condensed'}>
      <div className={'ccfp__content__condensed__card-provider'}>
        {cardsList.map(card => (
          <div
            key={card.code}
            className={'ccfp__content__condensed__card-provider__card'}
          >
            <img src={card.image} role={'presentation'} />
          </div>
        ))}
      </div>
      <div className={'ccfp__content__condensed__card-number'}>
        {`${cardLegend} ${cardNumber}`}
      </div>
      <button
        className={'ccfp__content__condensed__modify-button'}
        onClick={onPressChangeView}
      >
        {textChangeView}
      </button>
    </div>
  );
};

Condensed.propTypes = {
  cardsList: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      image: PropTypes.string,
    }),
  ).isRequired,
  cardNumber: PropTypes.string.isRequired,
  cardLegend: PropTypes.string.isRequired,
  textChangeView: PropTypes.string.isRequired,
  onPressChangeView: PropTypes.func.isRequired,
};

export default Condensed;
